import { createFileRoute } from "@tanstack/react-router"
import { ExclamationCircleIcon } from "@heroicons/react/24/outline"
import ScreenWrapper from "@/components/ScreenWrapper"

export const Route = createFileRoute("/geen-rol/")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <ScreenWrapper className="flex screen-height-minus-navbar items-center justify-center">
      <div className="bg-light-red border border-red rounded-[4px] px-6 py-6 flex flex-col items-center gap-4 max-w-[532px] w-full text-center">
        <ExclamationCircleIcon className="size-5 text-red" />
        <p className="font-bold">
          <span className="block">
            Je hebt nog geen rol toegewezen gekregen.
          </span>
          <span className="block">Neem contact op met de IT afdeling.</span>
        </p>
      </div>
    </ScreenWrapper>
  )
}
